import { NotificationType } from '~/entities/Notification'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { myPalette } from '~/shared/ui/theme'
import { ActionsBlock, Description, Title, TitleWrapper } from './styled'

type NotificationListDrawerProps = {
  isShow: boolean
  onClose: () => void
  onActionClick: () => void
}

const list: NotificationType[] = [
  {
    id: '1',
    title: 'Вам необходимо записаться на ТО',
    description:
      'Ваш километраж превысил 8000 км. Выбрать дату прохождения ТО вы можете во вкладке профиля.',
    date: '12.04.2022',
    actions: 'Записаться',
  },
  {
    id: '2',
    title: 'Ваш друг присоединился к реферальной программе',
    description:
      'Дулмачев Константин Сергеевич присоединился к нам по реферальной программе. По истечению трёх дней вам начислится 1500 ₽.',
    date: '12.04.2022',
    actions: 'Реферальная программа',
  },
  {
    id: '3',
    title: 'Ваш друг присоединился к реферальной программе',
    description:
      'Дулмачев Константин Сергеевич присоединился к нам по реферальной программе. По истечению трёх дней вам начислится 1500 ₽.',
    date: '12.04.2022',
    actions: 'Реферальная программа',
  },
  {
    id: '4',
    title: 'Ваш друг присоединился к реферальной программе',
    description:
      'Дулмачев Константин Сергеевич присоединился к нам по реферальной программе. По истечению трёх дней вам начислится 1500 ₽.',
    date: '12.04.2022',
    actions: 'Реферальная программа',
  },
  {
    id: '5',
    title: 'Ваш друг присоединился к реферальной программе',
    description:
      'Дулмачев Константин Сергеевич присоединился к нам по реферальной программе. По истечению трёх дней вам начислится 1500 ₽.',
    date: '12.04.2022',
    actions: 'Реферальная программа',
  },
  {
    id: '6',
    title: 'Ваш друг присоединился к реферальной программе',
    description:
      'Дулмачев Константин Сергеевич присоединился к нам по реферальной программе. По истечению трёх дней вам начислится 1500 ₽.',
    date: '12.04.2022',
    actions: 'Реферальная программа',
  },
]

export function NotificationListDrawer({
  isShow,
  onClose,
  onActionClick,
}: NotificationListDrawerProps) {
  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      {list.map((notification) => (
        <div key={notification.id} style={{ marginBottom: '24px' }}>
          <TitleWrapper>
            <Title>{notification.title}</Title>
          </TitleWrapper>
          <Description>{notification.description}</Description>

          <ActionsBlock>
            <Button
              contentProps={{ style: { padding: 0 } }}
              onClick={onActionClick}
              variant='textLink'
            >
              {notification.actions}
            </Button>
            <div style={{ fontSize: '12px', color: myPalette.mutedText.main }}>
              {notification.date}
            </div>
          </ActionsBlock>
        </div>
      ))}
    </DrawerComponent>
  )
}
